module.exports = __webpack_public_path__ + "static/media/baner_servizi_header.bdd963c5.png";